import React, { useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { FPIconButton, When } from 'UI/components/atoms';
import { SvgArrowDown, SvgArrowUp } from 'UI/res';

import { BulkEmailSequenceStepStatusChip } from '../BulkEmailSequenceStepStatusChip';

import { useBulkEmailSectionsCollapserStyles } from './BulkEmailSectionsCollapser.styled';

export const BulkEmailSectionsCollapser = ({
  children,
  CollapseProps = {},
  shouldShowCollapseButton = false,
  shouldShowBottomDivider = false,
  shouldShowTitle = false,
  shouldShowTopDivider = false,
  status = null,
  title
}) => {
  const classes = useBulkEmailSectionsCollapserStyles();
  const [open, setOpen] = useState(true);

  return (
    <Grid container>
      <When condition={shouldShowTopDivider}>
        <Divider className={classes.divider} />
      </When>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.header}
        wrap="nowrap"
      >
        <Grid container item justify="flex-start" alignItems="center">
          <When condition={shouldShowTitle}>
            <Typography variant="h6">{title}</Typography>
          </When>
          <When condition={status}>
            <BulkEmailSequenceStepStatusChip status={status} />
          </When>
        </Grid>
        <When condition={shouldShowCollapseButton}>
          <FPIconButton icon={open ? SvgArrowUp : SvgArrowDown} onClick={() => setOpen(!open)} />
        </When>
      </Grid>
      <Collapse in={open} className={classes.collapse} {...CollapseProps}>
        {children}
      </Collapse>
      <When condition={shouldShowBottomDivider && !open}>
        <Divider className={classes.divider} />
      </When>
    </Grid>
  );
};
